import { useState, useEffect, useRef } from 'react';
import { getUrl } from './../../../common/utils';
import './BreakingNewsTicker.css';
import { PAGEBUILDER_URLS } from '../../Common/Constant';


export function BreakingNewsTicker(props: any) {
    const { HeadingBGColor, HeadingTextColor, BGColor, TextColor } = props;
    const [notifications, setNotifications] = useState<any[]>([]);
    const intervalIdRef = useRef<NodeJS.Timeout>();

    const fetchBreakingNewsData = async () => {
        const apiUrl = getUrl(props);
        try {
            const response = await fetch(apiUrl);
            if (!response.ok) {
                //throw new Error("Network response was not ok");
            }
            const responseData = await response.json();
            if (responseData && responseData?.response && responseData?.response?.data) {
                const activeNotifications = responseData.response.data.filter((item: any) => item.status === 'ACTIVE');
                setNotifications(responseData.response.data);
                if (activeNotifications.length > 0) {
                    clearInterval(intervalIdRef.current); // Clear current interval
                    intervalIdRef.current = setInterval(fetchBreakingNewsData, 30000); // Set new interval
                }
            } else {
                setNotifications([]);
                //console.log('No active notifications found.');
            }
        } catch (error) {
            //console.error("Error", error);
            setNotifications([]);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
            setNotifications([{ "id": '', "hostid": '', "status": '', "type": '', "text": "This is Breaking News Ticker", "overridelink": "" }])

        }
        else {
            fetchBreakingNewsData();
            intervalIdRef.current = setInterval(fetchBreakingNewsData, 30000);
            return () => {
                clearInterval(intervalIdRef.current); // Clear interval on component unmount
            };
        }
    }, []);
    //console.log('notifications', notifications)
    return notifications.length > 0 && (
        <div className="breaking-news-ticker">
            <div className="ticker-wrap" style={{ backgroundColor: BGColor }}>
                <div className="ticker-heading" style={{ backgroundColor: HeadingBGColor, color: HeadingTextColor }}>Breaking News</div>
                    <div className="ticker">
                        {notifications.map((item, index) => {
                            const link = item.overridelink || '';
                            return (
                                <div className="ticker__item" key={item.id}>
                                    {link !== '' ? (
                                        <a href={`${link}`} style={{ color: TextColor }}>{item.text}</a>
                                    ) : (
                                        <span style={{ color: TextColor }}>{item.text}</span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
            </div>
        </div>
    );
}



